<div class="app-banner" *ngIf="showBanner">
  <div class="app-banner__content">
    <div class="app-banner__logo">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="28" height="28" rx="6" fill="#FFCC00"/>
        <text x="14" y="20" text-anchor="middle" font-size="16" font-weight="800" font-family="Poppins,sans-serif" fill="#000">B</text>
      </svg>
    </div>
    <div class="app-banner__text">
      <span class="app-banner__title">Bipperz</span>
      <span class="app-banner__subtitle">{{ 'mobile_notifications.mobile_warning' | translate }}</span>
    </div>
  </div>

  <div class="app-banner__actions">
    <a class="app-banner__store-btn" [href]="googlePlayUrl" target="_blank" rel="noopener noreferrer" aria-label="Get it on Google Play">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.18 23.76c.36.2.77.24 1.16.12L14.84 12 4.34.12C3.95 0 3.54.04 3.18.24 2.46.64 2 1.4 2 2.28v19.44c0 .88.46 1.64 1.18 2.04z"/>
        <path d="M22.22 10.62l-3.5-2-4.34 3.38 4.34 3.38 3.54-2.02c1.02-.58 1.02-2.16-.04-2.74z"/>
        <path d="M4.34.12L14.84 12l-4 4L3.18.24c.12-.04.23-.08.36-.08.27 0 .54.07.8.2V.12z" opacity="0"/>
        <path d="M14.84 12L4.34 23.88l7.5-7.88 3-4z" opacity="0"/>
        <path d="M4.34.12l6.5 6.5-6.5 6.5V.12z" fill="#fff" opacity="0"/>
      </svg>
      <span>{{ 'mobile_notifications.google_play' | translate }}</span>
    </a>
    <a class="app-banner__store-btn" [href]="appStoreUrl" target="_blank" rel="noopener noreferrer" aria-label="Download on the App Store">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98l-.09.06c-.22.15-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04l-.08.27zM13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
      </svg>
      <span>{{ 'mobile_notifications.app_store' | translate }}</span>
    </a>
  </div>

  <button class="app-banner__close" (click)="dismiss()" [attr.aria-label]="'mobile_notifications.dismiss' | translate">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 1L1 13M1 1l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>
</div>